import { useState, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import { getPendingPurchases } from '../api';
import usePurchaseEvents from './usePurchaseEvents';
import { normalizePaginatedResponse } from '../utils/pagination';

const usePendingPurchases = (branchId, options = {}) => {
  const { enableRealtime = false, includeSuspended = true } = options;

  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPending = useCallback(async () => {
    if (!branchId) return;

    setLoading(true);
    setError(null);

    const today = format(new Date(), 'yyyy-MM-dd');

    try {
      const result = await getPendingPurchases(
        branchId,
        today,
        today,
        undefined,
        includeSuspended,
        { pageSize: 0 }
      );
      const normalized = normalizePaginatedResponse(result);
      const filtered = (normalized.data || []).filter(
        (p) => !p.isDeleted && p.totalAmount > 0
      );
      setPending(filtered);
    } catch (err) {
      console.error('Error fetching pending purchases:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [branchId, includeSuspended]);

  useEffect(() => {
    fetchPending();
  }, [fetchPending]);

  usePurchaseEvents(
    branchId,
    (data) => {
      if (
        enableRealtime &&
        data &&
        (data.type === 'purchase-created' ||
          data.type === 'purchase-deleted' ||
          data.type === 'purchase-paid' ||
          data.type === 'purchase-suspended' ||
          data.type === 'purchase-resumed')
      ) {
        fetchPending();
      }
    },
    { enabled: !!branchId }
  );

  const reload = useCallback(() => {
    fetchPending();
  }, [fetchPending]);

  return { pending, reload, loading, error };
};

export default usePendingPurchases;
